import { render, staticRenderFns } from "./AboutTeam.vue?vue&type=template&id=b760c0a0&"
import script from "./AboutTeam.vue?vue&type=script&lang=js&"
export * from "./AboutTeam.vue?vue&type=script&lang=js&"
import style0 from "./AboutTeam.vue?vue&type=style&index=0&id=b760c0a0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports